import { Navigate } from 'react-router-dom';

import { Body1, Heading1, Stack } from '@myphx-engineering/phx-design-system';

import { PrescriberOrderStatus } from '../../../graphql/generated/graphql';
import { getAbsoluteRoute } from '../../../util/get-absolute-route';

import { KeepCurrentPrescriptionButton } from './KeepCurrentPrescriptionButton';
import { useSwitchPrescription } from './shared';
import { SwitchOtherOptions } from './SwitchOtherOptions';
import { SwitchTargetSelector } from './SwitchTargetSelector';

const SwitchOptionsPage = () => {
    const { order, orderId, switchConfig } = useSwitchPrescription();

    if (order.status === PrescriberOrderStatus.OnHold) {
        return (
            <Navigate
                replace
                to={getAbsoluteRoute('order.prescriberOrderId.details', {
                    prescriberOrderId: orderId,
                })}
            />
        );
    }

    return (
        <Stack gap="lg">
            <Stack gap="sm">
                <Heading1>{switchConfig.heading}</Heading1>
                <Body1>{switchConfig.description}</Body1>
            </Stack>

            <SwitchTargetSelector
                prescriberOrderId={orderId}
                switchConfig={switchConfig}
            />

            <KeepCurrentPrescriptionButton prescriberOrderId={orderId} />
            <SwitchOtherOptions order={order} />
        </Stack>
    );
};

export default SwitchOptionsPage;
